import { render } from "./WorkerSettings.vue?vue&type=template&id=314d71f8&scoped=true"
import script from "./WorkerSettings.vue?vue&type=script&lang=js"
export * from "./WorkerSettings.vue?vue&type=script&lang=js"

import "./WorkerSettings.vue?vue&type=style&index=0&id=314d71f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-314d71f8"

export default script